import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import LightBox from '@bd/bdui-lightbox';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import PlatmapModal from './PlatmapModal';
import { colors, typography } from '../../styles';

const styles = css`
  margin-bottom:100px;
  .Banner_Title {
    color:  white;
    font:700 18px/1 ${typography.SansSerif};
    padding:20px 30px;
    border:1px solid ${colors.color1};
    text-transform: uppercase;
    display: inline-block;
    margin-bottom: 24px;
    background: ${colors.color1};
    @media (min-width: 992px) {
      font:700 24px/1 ${typography.SansSerif};
    }
  }
  h2 {
    font:700 24px/1.4 ${typography.SansSerif};
    color:  ${colors.color1};
    display:block;
    width:100%;
    text-transform: capitalize;
    margin-bottom:30px;
  }
  .Banner_Body {
    font:400 16px/34px ${typography.SansSerif};
    color:  ${colors.color5};
    @media (min-width: 992px) {
      font:400 18px/40px ${typography.SansSerif};
    }
  }
  .linkLike {
    color:  ${colors.color1};
    cursor:pointer;
    transition: all .25s ease;
  }
  .linkLike:hover {
    color:  ${colors.color1Darkest};
    cursor:pointer;
  }
  .PlanActions {
    padding-bottom:30px;
    li {
      padding:4px 0;
    }
  }
  .PlanPrice {
    font-size: 36px;
    margin-bottom: 15px;
  }
`;

function PlanDetailContent({ plan }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="Banner_Title">Description</div>
            <ul className="list-unstyled PlanActions">
              {get(plan, 'price') > 0 &&
                <li className="PlanPrice">
                  ${numeral(get(plan, 'price')).format('0,0')}
                </li>
              }
              {
                !!get(plan, 'plat_map') &&
                <li>
                  <PlatmapModal plan={plan}>
                    <strong className="linkLike" role="button" tabIndex="0"><img src="/images/icon-lots.svg" alt="" width="40" height="40" /> View Plat Map</strong>
                  </PlatmapModal>
                </li>
              }
              {
                !!get(plan, 'plan_brochure') &&
                <li className="plan-brochure"><strong><a href={plan.plan_brochure.contentUrl} target="_blank" rel="noopener noreferrer" className="linkLike"><img src="/images/icon-file.svg" alt="" width="40" height="40" /> Download Brochure</a></strong></li>
              }
              <li>
                {
                  get(plan, 'floorplanPhotos').length > 0 &&
                    <LightBox
                      items={get(plan, 'floorplanPhotos', [])}
                      button={(
                        <div className="btn">
                          <span>View Floor Plans</span>
                        </div>
                      )}
                    />
                }
              </li>
            </ul>
          </div>
          <div className="col-lg-8">
            {
              get(plan, 'headline') &&
              <h2>{get(plan, 'headline')}</h2>
            }
            <span className="Banner_Body">{get(plan, 'description')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

PlanDetailContent.propTypes = {
  plan: PropTypes.object.isRequired,
};

export default withData(
  {
    plan: true,
  },
  {
    required: {
      plan: true,
    },
  },
)(PlanDetailContent);



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanDetailContent.js